
import { CartItemModel } from './cart-item.model'
export class SaveCartModel {
    CartItem: CartItemModel;
    // Added this string type variable to save the search criteria into the database for user.
    SearchString: string;
    CartRequestTypeId?: number;
}